import { render, staticRenderFns } from "./promotions-partial.vue?vue&type=template&id=47d23f64"
import script from "./promotions-partial.vue?vue&type=script&lang=js"
export * from "./promotions-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports